module.exports = __webpack_public_path__ + "img/daily_specials_4.c8a3117b.jpg";